import { usePSNavigate } from '../../hooks/usePSNavigate'
import { BOOK_BASE } from '../../utils/constants'
import Button from '../app/design/Button'
import Heading from '../app/design/Heading'

export const SetupReaderPage = () => {
    const navigate = usePSNavigate()

    const orderReader = () => {
        navigate('/settings/reader/checkout')
    }

    const addReader = () => {
        navigate('/settings/reader/add')
    }

    return (
        <div className="flex min-h-screen w-full flex-col items-center">
            <div className="flex w-[648px] flex-col items-start">
                <div className="pt-6 pl-8">
                    <div className="flex pb-2">
                        <Button
                            intent="tertiaryLink"
                            leftIcon="chevronLeft.medium"
                            onClick={() => navigate(-1)}
                            className="px-0"
                            isDense
                        >
                            Settings
                        </Button>
                    </div>
                    <Heading className="text-gray-700">Card Reader</Heading>
                </div>
                <div className="relative flex flex-col items-center bg-gray-100">
                    <img alt="card reader" src="/icons/card-reader-splash.png" />

                    <div className="absolute bottom-0 flex w-full translate-y-1/2 flex-col items-center">
                        <div className="w-full rounded-xl bg-white p-6 shadow-lg">
                            <div className="flex flex-col items-center gap-4">
                                <h1 className="mt-8 text-center text-[36px] leading-[44px] font-bold text-gray-700">
                                    Card Reader
                                </h1>

                                <p className="text-center text-base leading-6 font-normal text-gray-600">
                                    Swipe, tap magnetic stripe, or read chip cards
                                </p>
                                <div className="mt-6 flex w-full flex-col items-stretch gap-3 px-8">
                                    <Button
                                        intent="secondary"
                                        size="medium"
                                        onClick={addReader}
                                        className="w-full"
                                    >
                                        Add an existing reader
                                    </Button>
                                    <Button
                                        intent="primary"
                                        size="medium"
                                        onClick={orderReader}
                                        className="w-full"
                                    >
                                        Order a card reader
                                    </Button>
                                </div>
                                <Button
                                    intent="tertiary_deprecated"
                                    onClick={() =>
                                        window.open(`${BOOK_BASE}/pos-card-reader`, '_blank')
                                    }
                                >
                                    Learn More
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
